import {
  Column,
  Icon,
  Row, Select, Spacer, Text
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { EntityType } from 'common/enums/entity-enums';
import {
  ArchiveQueryCondition,
  ICondition,
} from 'common/interfaces/query';
import {
  entityTableLabelMap,
  getParametersFromEntityType
} from 'common/table-viewer/utils';
import {
  conditionLabelMap,
  getConditionDataTypeKey,
  getEntityMetadataOptions,
  getEntityParameterEnums, getEntityPropertyOptions
} from '../query-utils';
import { QueryConditionCell } from './query-condition-cell';
import { useTranslation } from 'react-i18next';

interface IQueryFormProps {
  updateCondition: (index: number, changes: Partial<ICondition>) => void;
  handleDeleteCondition: (index: number) => void;
  conditions: ICondition[];
}

const entityOptions = Object.values(EntityType).map(value => ({
  label: entityTableLabelMap[value],
  value,
}));

const conditionOptions = Object.values(ArchiveQueryCondition).map(value => ({
  label: conditionLabelMap[value],
  value,
}));

export const QueryRow = (
  {
    handleDeleteCondition,
    updateCondition,
    conditions
  }: IQueryFormProps,
) => {
  const { t } = useTranslation();
  const queryRow = (item: ICondition, index: number) => {
    const propOptions = getEntityPropertyOptions(item.entityType);
    const metaOptions = getEntityMetadataOptions(item.entityType);

    const options = [
      { label: 'Entity Parameter', type: 'Heading' },
      ...propOptions,
      ...(metaOptions.length === 0 ? []
        : [
          { label: 'Metadata', type: 'Heading' },
          ...metaOptions,
        ]
      )];

    return (
      <Row key={`${getConditionDataTypeKey(item)}-${index}`} marginBottom="var(--padding)">
        <Column width={320}>
          <Text bold>{t(translations.query_entityType)}</Text>
          <Spacer height="var(--padding-xxs)" />
          <Select
            value={item.entityType}
            options={entityOptions}
            onChange={(event) => {
              const entityType = event.target.value as EntityType;
              updateCondition(index, {
                entityType,
                entityPropertyName: getParametersFromEntityType(entityType)[0],
                condition: ArchiveQueryCondition.EQ,
                conditionValue: undefined,
              });
            }}
          />
        </Column>
        <Column width={240}>
          <Text bold>{t(translations.query_entityParameter)}</Text>
          <Spacer height="var(--padding-xxs)" />
          <Select
            value={item.entityPropertyName}
            options={options}
            onChange={(event) => {
              updateCondition(index, { entityPropertyName: event.target.value, conditionValue: undefined });
            }}
          />
        </Column>
        <Column width={80}>
          <Text bold>{t(translations.query_condition)}</Text>
          <Spacer height="var(--padding-xxs)" />
          <Select
            value={item.condition}
            options={conditionOptions}
            name="condition"
            onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
            disabled={!!getEntityParameterEnums(item.entityType, item.entityPropertyName)}
          />
        </Column>

        <Column width={240}>
          <Text bold>{t(translations.query_conditionValue)}</Text>
          <Spacer height="var(--padding-xxs)" />
          <QueryConditionCell item={item} index={index} updateCondition={updateCondition} />
        </Column>
        <Column width={60}>
          <Spacer height="var(--padding-xl)" />
          <Column width="var(--padding-l)">
            <Icon
              icon="clear"
              color="var(--color-neutral-550)"
              size={28}
              onClick={() => handleDeleteCondition(index)}
            />
          </Column>
        </Column>
      </Row>
    );
  };

  const renderQueryRow = () => {
    return conditions.map(queryRow);
  };

  return renderQueryRow()
};
